import { createContext } from "react";

const AdmissionContext = createContext();

export default AdmissionContext;
